import { useLocation } from "react-router-dom";
import CustomButton from "../../components/customButton";
// import HomeSidebar from "../../components/homeSidebar";
import Nav from "../../components/nav";
import ProductCard from "../../components/productCard";
// import useFruitStore from "../../store/fruits";
import { useEffect, useState } from "react";
import axios from "axios";
import { categories_products } from "../../lib/apis";
import Loader from "../../components/loader";
import { useTranslation } from "react-i18next";
import Breadcrumb from "../../components/Breadcrumb";
import { scrollToTop } from "../../lib/utils";

const CategorieDetails = () => {
  // const { filteredFruits } = useFruitStore();
  const locations = useLocation()
  const categorie = locations.state
  const [categories, setCategories] = useState(categorie)
  const [products, setProducts] = useState<any[]>([])
  const [filterProduct, setFilterproduct] = useState<any[]>([])
  const [subCategories, setSubCategories] = useState<any[]>([])
  const [loading, setLoading] = useState(true)
  const [allDataSubCat, setAllDataSubCat] = useState<any>()
  const labelSearch = categories.subCat ? categories.subCat.sub_category_name : "Tout"

  const [value, setValue] = useState(labelSearch)
  const { t, i18n } = useTranslation()


  useEffect(() => {
    scrollToTop()
  }, [])

  useEffect(() => {
    setLoading(true)
    setCategories(categorie)
    setLoading(false)
  }, [categorie])
  const updateProduct = async () => {
    setLoading(true)
    try {
      const { data } = await axios.get(`${categories_products}/${categories.category_id}/products`)
      console.log(data)
      setProducts(data.products)
      if (categories.subCat) {
        const filterProduct = data.products.filter((item: any) => item.sub_category_id === categories.subCat.sub_category_id)
        setFilterproduct(filterProduct)
      }
      else {
        setFilterproduct(data.products)
      }

    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }
  const updateSubCategories = async () => {
    const currentLanguage = i18n.language
    try {
      const { data } = await axios.get(`${categories_products}/${categories.category_id}/subcategories`)
      console.log(data)
      setAllDataSubCat(data)
      if (currentLanguage === "fr") {
        setSubCategories(data.data)
      } else {
        setSubCategories(data.dataE)
      }

    } catch (error) {
      console.log(error)
    } finally {
    }
  }
  useEffect(() => {
    const currentLanguage = i18n.language
    if (allDataSubCat) {
      if (currentLanguage === "fr") {
        setSubCategories(allDataSubCat.data)
      } else {
        setSubCategories(allDataSubCat.dataE)
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language])
  useEffect(() => {
    updateSubCategories()
    // eslint-disable-next-line
  }, [categories])

  const handleChange = (value: string) => {
    const label = value.toLocaleLowerCase()
    setValue("Tout")
    const search = products.filter((item: any) => item.product_name.toLocaleLowerCase().includes(label) || item.sale_name.toLocaleLowerCase().includes(label) || item.variety.toLocaleLowerCase().includes(label))
    setFilterproduct(search)
  }

  useEffect(() => {
    setValue(labelSearch)
    updateProduct()
    // eslint-disable-next-line
  }, [labelSearch, categories])
  console.log("filterProducts", filterProduct)

  return (
    <div className="flex flex-1 flex-col items-center mt-24 gap-4 w-full">
      <Nav products={products} setFilterproduct={setFilterproduct} t={t} value={value} setValue={setValue} subCategorie={subCategories} />
      <div className="w-full px-4 md:px-8">
        <div className="flex gap-[0.8px] w-full">
          <div
            style={{ boxShadow: "0px 4px 4px 0px hsla(0, 0%, 0%, 0.25)" }}
            className="min-w-[150px] sm:min-w-[250px] md:min-w-[357px] flex-grow border-[2px] h-[37px] rounded-l-[29px] border-solid border-grey relative"
          >
            <div className="absolute left-2 top-0 bottom-0 flex items-center">
              <img src="/greySearch.svg" alt="" />
            </div>
            <input
              onChange={(e) => handleChange(e.target.value)}
              className="placeholder:text-grey rounded-l-[29px] pl-8 text-xs font-normal h-full w-full border-none focus:outline-none focus:ring-0 focus:border-transparent"
              placeholder="Rechercher un produit"
            />
          </div>
          <CustomButton
            startIcon="/search-icon.svg"
            className="h-[38px] bg-black rounded-r-[29px] w-[80px] sm:w-[120px] px-3 py-2"
          >
            <span className="text-xs font-normal text-white">{t("recherche")}</span>
          </CustomButton>
        </div>
      </div>
      <div className="flex flex-row py-5 items-center justify-start w-full ml-14">

        <Breadcrumb />
      </div>
      <div className="w-full px-8 md:px-8 flex-grow">
        <div className="grid grid-cols-1  sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {loading ? <Loader /> :
            filterProduct.map((product: any, index) => {
              const images = JSON.parse(product.images)
              return (
                <ProductCard
                  key={index}
                  category_name={product.category_name}
                  image={images[0]}
                  uml={i18n.language === "fr" ? product.type : product.type_en}
                  sub_category_name={product.sub_category_name}
                  title={i18n.language === "fr" ? product.product_name : product.product_name_en}
                  quality={product.minimum_quantity}
                  price={product.price}
                  stock={product.Stocks ? product.Stocks[0]?.quantity : 0}
                  quantity={product.quantity}
                  productId={product.product_id}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};
export default CategorieDetails;
